import InputBase from './MultipleSelect';
export * from './MultipleSelect';
export const MultipleSelect = InputBase;

export default InputBase;
